import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Header";
import Pagination from "react-js-pagination";
import RsuiteChecker from "../../RsuiteChecker";
import LiveStreamInfoList from "./LiveStreamInfoList";
import { ToastContainer } from "react-toastify";
import Confirm from "../modals/Confirm";
import StopLiveStreamConfirm from "../modals/StopLiveStreamConfirm";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import { getCookie } from "../../common/Utility";

const environmentNames = [
  { value: "Dev", id: "dev" },
  { value: "Staging", id: "staging" },
  { value: "Pre Prod", id: "preprod" },
  { value: "Prod", id: "prod" },
];

const initialEnvState = () => {
  const state = {};
  environmentNames.forEach((env) => {
    state[env.id] = { data: [], loading: true, totalCount: 0 };
  });
  return state;
};

const LiveStreamInfo = () => {
  const [liveDataByEnv, setLiveDataByEnv] = useState(initialEnvState());
  const [playoutDataByEnv, setPlayoutDataByEnv] = useState(initialEnvState());
  const [activeTab, setActiveTab] = useState("live"); // "live" or "playout"
  const [confirmModalData, setConfirmModalData] = useState(null);
  const [stopLiveStreamModalData, setStopLiveStreamModalData] = useState(null);
  const [muviUserId, setMuviUserId] = useState(0);

  let user_uuid = getCookie("muvi_useruuid");

	function decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	function decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

  const fetchEnvironmentData = (key, envId, setDataByEnv) => {
    // Set loading for this environment
    setDataByEnv((prev) => ({
      ...prev,
      [envId]: { ...prev[envId], loading: true },
    }));

    const requestBody = { key, server: envId };

    fetch(`${process.env.REACT_APP_CRM}/muvi6/get-livestream-info`, {
      method: "POST",
      body: JSON.stringify(requestBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.code == 200) {
          setDataByEnv((prev) => ({
            ...prev,
            [envId]: {
              data: data.data || [],
              loading: false,
              totalCount: (data.data || []).length,
            },
          }));
        } else {
          setDataByEnv((prev) => ({
            ...prev,
            [envId]: { data: [], loading: false, totalCount: 0 },
          }));
        }
      })
      .catch((error) => {
        console.error(`Fetch error for ${envId}:`, error.message);
        setDataByEnv((prev) => ({
          ...prev,
          [envId]: { data: [], loading: false, totalCount: 0 },
        }));
      });
  };

  const fetchAllLive = () => {
    setActiveTab("live");
    environmentNames.forEach((env) => {
      fetchEnvironmentData("live", env.id, setLiveDataByEnv);
    });
  };

  const fetchAllPlayout = () => {
    setActiveTab("playout");
    environmentNames.forEach((env) => {
      fetchEnvironmentData("playout", env.id, setPlayoutDataByEnv);
    });
  };

  // CTA Related Work
  const handleClickConfirmModal = (
    confirmText,
    product_key,
    type,
    app_token,
    server,
  ) => {
    setConfirmModalData({
      confirmText,
      product_key,
      user_uuid,
      type,
      server,
      muviUserId,
      app_token,
    });
    const confirmModal = document.getElementById("confirmModal");
    confirmModal.classList.add("show");
    confirmModal.style.display = "block";
  };

  const handleClickStopLiveStreamConfirmModal = (
    confirmText,
    product_key,
    livestream_uuid,
    type,
    app_token,
    server,
  ) => {
    setStopLiveStreamModalData({
      confirmText,
      product_key,
      user_uuid,
      livestream_uuid,
      type,
      server,
      app_token,
    });
    const stopLiveStreamConfirmModal = document.getElementById(
      "stopLiveStreamConfirmModal",
    );
    stopLiveStreamConfirmModal.classList.add("show");
    stopLiveStreamConfirmModal.style.display = "block";
  };

  useEffect(() => {
    fetchAllLive();
  }, []);

  useEffect(() => {
    // Getting Muvi userid to return login url as a parameter
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? decrypt(localStorage.getItem("encdata"), 0)
      : "";
    setMuviUserId(localdata && localdata.user_id);
  }, []);

  const currentDataByEnv =
    activeTab === "live" ? liveDataByEnv : playoutDataByEnv;

  return (
    <div>
      <Header brecum_name="Stream Info" brecum_page="Stream Info" />
      <ToastContainer />
      <div className="right_col">
        <div className="customer-wrap">
          <section className="customer">
            <div id="exTab1" className="container">
              <ul className="nav nav-pills nav-tabs">
                <li className={activeTab === "live" ? "active" : ""}>
                  <a
                    href="#MuviLive"
                    data-toggle="tab"
                    onClick={() => fetchAllLive()}
                  >
                    Muvi Live
                  </a>
                </li>
                <li className={activeTab === "playout" ? "active" : ""}>
                  <a
                    href="#MuviPlayout"
                    data-toggle="tab"
                    onClick={() => fetchAllPlayout()}
                  >
                    Muvi Playout
                  </a>
                </li>
              </ul>
              <div className="tab-content clearfix">
                <div className="tab-pane active">
                  <div className="row">
                    <div className="body-content">
                      {environmentNames.map((env) => {
                        const envData = currentDataByEnv[env.id];
                        return (
                          <div key={env.id} style={{ marginBottom: "30px" }}>
                            <h4
                              style={{
                                padding: "10px 5px",
                                margin: "0",
                                // background: "#f5f5f5",
                                borderBottom: "2px solid #ddd",
                                fontWeight: "600",
                                color: "#333",
                              }}
                            >
                              {env.value}
                            </h4>
                            <div
                              className="table-wrap"
                              style={{ padding: "5px", minHeight: "auto" }}
                            >
                              <LiveStreamInfoList
                                livestreamData={envData.data}
                                totalCount={envData.totalCount}
                                loading={envData.loading}
                                server={env.id}
                                handleClickConfirmModal={(
                                  confirmText,
                                  product_key,
                                  type,
                                  app_token,
                                  server
                                ) =>
                                  handleClickConfirmModal(
                                    confirmText,
                                    product_key,
                                    type,
                                    app_token,
                                    server,
                                  )
                                }
                                handleClickStopLiveStreamConfirmModal={(
                                  confirmText,
                                  product_key,
                                  livestream_uuid,
                                  type,
                                  app_token,
                                  server
                                ) =>
                                  handleClickStopLiveStreamConfirmModal(
                                    confirmText,
                                    product_key,
                                    livestream_uuid,
                                    type,
                                    app_token,
                                    server
                                  )
                                }
                                type={activeTab}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {/* CTA Modals */}
                <Confirm data={confirmModalData} />
                <StopLiveStreamConfirm data={stopLiveStreamModalData} />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamInfo;



// WEBPACK FOOTER //
// ./src/components/crm/livestream/LiveStreamInfo.js